// extracted by mini-css-extract-plugin
export default {"root":"AlbumsLayout__root--qkyrR"};